import CustomFilterSelect from "./CustomFilterSelect";

const FilterDisbursementStatus = (props: any) => {
  const FilterData = [
    { id: "Completed", name: "Completed" },
    { id: "In-Progress", name: "In-Progress" },
    { id: "Offline", name: "Offline" },
    { id: "Pending", name: "Pending" },
    { id: "Failed", name: "Failed" },
    // { id: "Canceled", name: "Canceled" },
    { id: "No Account", name: "No Account" },
  ];
  const authrole = localStorage?.getItem("authrole")?.toString();
  return (
    <CustomFilterSelect
      source="disbursementStatus"
      label="Disbursement Status"
      choices={FilterData}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterDisbursementStatus;
